


import React from "react";
import expandImg from "../../images/expander.png";
import "./question.css";

export default function Question({ item, isMobile }) {
  return (
    <details className="question-wrapper">
    <summary className="custom-rounded-border bg-inherit cursor-pointer flex justify-between">
      <p className="text-start qa-question">{item.question}</p>
      <img
        src={expandImg}
        className="ml-12"
        width="30px"
        height="30px"
        alt="expand-img"
        style={{
          maxWidth: isMobile ? 16: 30,
          maxHeight: isMobile ? 16 : 30
        }}
      />
    </summary>
    <div className="qa-answer pt-3 custom-rounded-border">
      <div className="bg-neutral-500 w-4/5 h-px mb-2"></div>
      <p className="text-start text-neutral-500">{item.answer}</p>
    </div>
  </details>
  );
}
